import { render } from "./HackathonHost.vue?vue&type=template&id=1b8770ce"
import script from "./HackathonHost.vue?vue&type=script&lang=js"
export * from "./HackathonHost.vue?vue&type=script&lang=js"
script.render = render

export default script